/* eslint-disable react/jsx-no-target-blank */
import { FC, useEffect, useState } from 'react'
import { BreadCrumbs } from '../../../company/components/Breadcrumbs'
import { Report, ReportAGTable } from './Components/InvestorReport'
import {
  GetPortfolioOverviewReportQuery,
  useGetPortfolioOverviewReportQuery,
} from '../../../../../generated/graphql'
import { graphqlRequestClient } from '../../../../../queries/client'

const InvestorReportsWrapper: FC = () => {
  const [reportData, setReportData] = useState<Report[]>([
    {
      reportName: 'Portfolio Overview',
      fileName: 'Portfolio_Overview_Report.xlsx',
      description: 'A comprehensive overview of the portfolio performance',
      fileLink: '',
    },
    {
      reportName: 'Company Wise Report',
      fileName: 'company-report.xlsx',
      description: 'Detailed report on individual company performance',
      fileLink: '',
    },
  ])

  // useEffect(() => {
  //   if (portfolioReports) {
  //     setReportData((prev) =>
  //       prev.map((report) =>
  //         report.reportName === 'Portfolio Overview'
  //           ? {
  //               ...report,
  //               fileLink: portfolioReports?.portfolioOverviewReport || '',
  //             }
  //           : report
  //       )
  //     )
  //   }
  // }, [portfolioReports])

  // if (isLoading)
  //   return (
  //     <div className='w-100 my-20 d-flex justify-content-center align-items-center'>
  //       <span className='spinner-grow'></span>
  //     </div>
  //   )

  return (
    <>
      <div className='row mb-6'>
        {' '}
        <BreadCrumbs label='Reports Overview' isActionItems={false} className=''>
          {' '}
        </BreadCrumbs>
      </div>

      <div className='row g-5 g-xl-10'>
        <div className='col-12'>
          <ReportAGTable reportData={reportData} />
        </div>
      </div>
    </>
  )
}

export { InvestorReportsWrapper }
